<template>
	<div style="width: 100%; height: 100%; padding-top: 20%;" @click.stop="stop_pro" >
    <div v-if="is_connected == true">
         <v-sparkline line-width="1" width="200" style="height: 20px; width: 50px;" padding="8" :color="color" :value="buffer_history"></v-sparkline>      
         <div :class="text_color" style="font-size:  10px;">{{buffer_max}}&nbsp; / &nbsp;{{buffer_status}}</div>
    </div>
	</div>
</template>

<script>

import EventModel from '@/models/event.js'
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'

export default {
	props: ["channel", "event", "destchannel"],
	data () {
		return {
      timestamp: 0,
      updater: undefined,
      connection_info: undefined,
      is_connected: false,
      buffer_history: [],
      buffer_max: 0,
      buffer_status: 0,
      color: "",
      text_color: ""
		}
	},
  components: {
  },
  mounted () {
    var self = this;
    this.timestamp = self.$store.state.timestamp;
    this.timestamp_update();

    this.updater = setInterval(function() {
      self.timestamp = self.$store.state.timestamp;
      self.timestamp_update();
    },1000);
  },
  beforeDestroy () {
    if (typeof(this.updater) != "undefined") {
      clearTimeout(this.updater);
    }
  },
	methods: {
    is_updater () {
      return typeof(updater) != "undefined";
    },
    timestamp_update() {
      this.connection_info = this.get_info();
      if (typeof(this.connection_info) != "undefined") {
        this.buffer_history = this.get_buffer_history(this.connection_info.status);
        this.buffer_status = this.get_buffer_status(this.connection_info.status);
        this.buffer_max = this.get_max_history(this.connection_info.status);
        this.is_connected = this.connection_info.status.state == "connected";
        this.color = "";
        this.text_color = "";
        if (this.buffer_max > 100) {
          this.color = "orange";
          this.text_color = "orange--text"
        } 
        if (this.buffer_max > 5000) {
          this.color = "red";
          this.text_color = "red--text";
        }
      } else {
        this.buffer_history = [];
        this.buffer_status = 0;
        this.buffer_max = 0;
        this.is_connected = false;
        this.color = "";
        this.text_color = "";
      }
    },
    stop_pro () {
    },
    get_buffer_history(data) {
      if (typeof(data != "undefined")) {
        if (typeof(data.info) != "undefined") {
          if (typeof(data.info.buffer_status.history) != "undefined") {
            return _.map(data.info.buffer_status.history, (data) => {
              if(_.isArray(data)) return data[1];
              return data;
            });
          }
        }
      }
      return [];
    },
    get_buffer_status(data) {
      if (typeof(data != "undefined")) {
        if (typeof(data.info) != "undefined") {
          return data.info.buffer_status.current_length;
        }       
      }
      return "";
    },
    get_max_history(data) {
      var history = this.get_buffer_history(data);
      return _.max(history);  
    },
 	  get_info () {
      var ch = EventModel.input_channel(this.event);
      if (typeof(ch) != "undefined") {
        var info = ChannelModel.status(ch);
        if (typeof(info) != "undefined") {
          var data = info.instance;
         
          var d  = _.find(data.destinations, (dest) => {
            return dest.events.includes(this.event.uuid);
          });

          if (typeof(d) != "undefined") {
            return d;
          }
        }
      }
    },
   
    get_color_for_state (state) {
      if (state == "listening") return this.$dark() ? "orange darken-2" : "yellow darken-3";
      if (state == "disconnected") return this.$dark() ? "red darken-3" : "red lighten-2";
      if (state == "connecting") return this.$dark() ? "orange darken-4" : "orange";
      if (state == "connected") return this.$dark() ? "green darken-3" : "green";
      return undefined;
    }
	},
	computed: {

	}
}
</script>
<style>

.dashboard_chip {
  width: 90% !important;
}
.dashboard_chip .v-chip__content {
  width: 100%;
  cursor: pointer !important;
}
.dashboard_chip .v-chip__content .v-chip__close {
  margin: 0px !important;
  margin-right: -3px !important;
}
.dashboard_chip .v-chip__content .v-icon--right {
  margin: 0px !important;
  margin-right: -11px !important;
}
.dashboard_chip .v-avatar {
	margin-left: -6px !important;
}

.margin {
	margin-top: 2px;
	margin-bottom: 2px;
}
.dashboard_link {
	cursor: pointer;
}
.gui_btn {
	font-size: 10px; height: 20px; min-width: 25px; width: 25px; max-width: 25px;
}
.channel-title {
/*word-break: break-all;
  white-space: normal;*/
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  }
.channel-title2 {

  text-align: left !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>
